import {STORAGE_KEYS as K,read,preserveRecovery,markInvalid} from './storage.js';

const object=v=>v!==null&&typeof v==='object'&&!Array.isArray(v);
const text=v=>typeof v==='string';
const optionalText=v=>v===undefined||text(v);
const list=(v,test)=>Array.isArray(v)&&v.every(test);
const kinds=['heart','star','flower','leaf'];
const result=['keep','shrink','park','drop'];
const decisions=['mine','later','release'];
const validators={
 [K.PARKING_LOT]:v=>list(Array.isArray(v)?v:v?.items,i=>object(i)&&text(i.text)&&optionalText(i.id)),
 [K.JAR]:v=>list(Array.isArray(v)?v:v?.marks,i=>text(i)||object(i)&&optionalText(i.kind)),
 [K.MVD]:v=>object(v)&&['full','minimum','permission'].every(k=>v[k]===undefined||object(v[k]))&&['full','minimum'].every(k=>Object.values(v[k]||{}).every(text))&&optionalText(v.permission?.own),
 [K.GOAL_FILTER]:v=>list(v,i=>object(i)&&text(i.id)&&text(i.goal)&&result.includes(i.result)&&optionalText(i.smallerVersion)),
 [K.FOCUS_TIMER]:v=>object(v)&&optionalText(v.task)&&(v.timer===undefined||object(v.timer)),
 [K.NEXT_STEP]:v=>object(v)&&text(v.task)&&v.task.length<=140&&text(v.step)&&v.step.length<=140&&['','tidy','message','paperwork','study','own'].includes(v.kind)&&['draft','trying','paused','done'].includes(v.status),
 [K.SHREDDER]:v=>list(v,i=>object(i)&&text(i.id)&&text(i.thought)&&text(i.rewrite)&&decisions.includes(i.decision)),
 [K.SHREDDER_DRAFT]:v=>object(v)&&text(v.thought)&&text(v.rewrite)&&(v.decision===null||decisions.includes(v.decision)),
 [K.THREAD]:v=>object(v)&&text(v.text),
 [K.TODAY]:v=>object(v)&&text(v.day)&&list(v.checked,text),
 [K.RECOVERY]:object
};
const allowed=new Set(Object.values(K));
function validRaw(key,raw){
 if(typeof raw!=='string')return false;
 if(key===K.SOUND)return ['on','off','true','false'].includes(raw);
 if(key===K.MOTION)return ['on','off'].includes(raw);
 if(key===K.WELCOME)return raw==='done';
 if(key===K.MVD_STEP)return ['1','2','3'].includes(raw);
 if(key===K.JAR_RECOVERY)return true;
 try{return validators[key]?.(JSON.parse(raw))===true}catch{return false}
}
export function inspectStoredData(){
 const recovered=[];
 for(const key of allowed){
  if(key===K.RECOVERY||key===K.JAR_RECOVERY)continue;
  const raw=read(key);if(raw===null||validRaw(key,raw))continue;
  preserveRecovery(key,raw);markInvalid(key);recovered.push(key);
 }
 return recovered;
}
export function exportData(){
 const data={};for(const key of allowed){const raw=read(key);if(raw!==null&&validRaw(key,raw))data[key]=raw}
 return {format:'adhd-no-shame-reset',version:1,exportedAt:new Date().toISOString(),data};
}
export function validateBackup(value){
 if(!object(value)||value.format!=='adhd-no-shame-reset'||value.version!==1||!object(value.data))throw new Error('Choose a Tinyish or No-Shame Reset backup exported from Settings.');
 for(const [key,raw] of Object.entries(value.data))if(!allowed.has(key)||!validRaw(key,raw))throw new Error('This backup contains an unsupported or damaged record. Nothing has been changed.');
 return value.data;
}
export function restoreData(data){
 const old={};for(const key of allowed){const raw=read(key);if(raw!==null)old[key]=raw}
 try{
  for(const key of allowed){if(key in data)localStorage.setItem(key,data[key]);else localStorage.removeItem(key)}
 }catch(error){
  for(const key of allowed){try{localStorage.removeItem(key)}catch{}}
  for(const key of allowed){try{if(key in old)localStorage.setItem(key,old[key]);else localStorage.removeItem(key)}catch{}}
  throw new Error('This browser could not complete the restore. Keep your backup file and free some storage before trying again.');
 }
}
export function resetData(){for(const key of allowed)localStorage.removeItem(key)}
export function downloadBackup(){
 const blob=new Blob([JSON.stringify(exportData(),null,2)],{type:'application/json'}),url=URL.createObjectURL(blob),link=document.createElement('a');
 link.href=url;link.download=`Tinyish-backup-${new Date().toISOString().slice(0,10)}.json`;link.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
}
